import { Reveal, Eyebrow } from "../components/Reveal";
import { INSTAGRAM } from "../lib/api";
import { Instagram, ArrowUpRight } from "lucide-react";

const LINES = [
  ["No", "logos for the sake of logos."],
  ["No", "restocks once it's gone."],
  ["Just", "biowash cotton and loud stories."],
];

export const Manifesto = () => (
  <section id="manifesto" className="px-5 py-24 md:px-12 md:py-36" data-testid="manifesto-section">
    <div className="mx-auto grid max-w-[1600px] gap-16 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Reveal><Eyebrow>Manifesto</Eyebrow></Reveal>
        <div className="mt-8 space-y-4">
          {LINES.map(([a, b], i) => (
            <Reveal key={b} delay={i * 0.1}>
              <p className="font-display text-5xl font-black uppercase leading-[0.9] md:text-7xl">
                <span className="text-[#00FF66]">{a}</span> {b}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal className="lg:col-span-5 lg:pt-16" delay={0.2}>
        <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="instagram-link" className="group block border border-white/15 p-6 transition-colors hover:border-[#00FF66]">
          <div className="flex items-center justify-between">
            <span className="flex items-center gap-3 font-mono text-sm uppercase tracking-widest"><Instagram className="h-5 w-5 text-[#00FF66]" /> @tbrand_111</span>
            <ArrowUpRight className="h-6 w-6 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
          </div>
          <div className="mt-6 grid grid-cols-3 gap-2">
            {["/img/n5.jpg", "/img/n2.png", "/img/n1.jpg"].map((s) => (
              <div key={s} className="aspect-square overflow-hidden">
                <img src={s} alt="T Brand street snap" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              </div>
            ))}
          </div>
          <p className="mt-6 font-display text-4xl font-black uppercase leading-none">Tag us. Get reposted.</p>
          <p className="mt-2 text-sm text-zinc-400">Traditional art, modern wear. Follow for drop dates and street snaps.</p>
        </a>
      </Reveal>
    </div>
  </section>
);
